/* */
import {
  Stack,
  Text,
  Grid,
  Group,
  Center,
  Switch,
  Accordion,
  Tooltip,
} from "@mantine/core";
import { IconSortAscending2, IconSortDescending2 } from "@tabler/icons";
import { useState } from "react";
import EthAddress from "../EthAddress/EthAddress";
import NickName from "../EthAddress/NickName";
import RegionInfo from "../RegionInfo/RegionInfo.js";
import "./styles.css";

export default function FullTable(props) {
  const [showOnline, setShowOnline] = useState(true);
  const sortedTranscoders = props.transcoderInfo;
  let sign = <IconSortDescending2 size={18} color={"#86c232"} />;
  if (props.ascending) {
    sign = <IconSortAscending2 size={18} color={"#86c232"} />;
  }
  return (
    <Stack spacing={0} sx={{ width: "100%" }}>
      <Group position="apart" spacing="28px">
        <Text size="xl" fw={700}>
          Pool Transcoders - {props.poolInfo.sessionSum}/
          {props.poolInfo.capacitySum} capacity
        </Text>
        <Switch
          checked={showOnline}
          onChange={(event) => setShowOnline(event.currentTarget.checked)}
          onLabel="Online"
          offLabel="All"
          size="xl"
          color="#86c232"
          radius="sm"
          styles={{
            root: {
              display: "table-cell",
              verticalAlign: "middle",
            },
            body: {
              display: "block",
            },
          }}
        />
      </Group>
      <Stack
        spacing={24}
        sx={{
          borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
          borderRadius: "7px",
          margin: 0,
        }}
      >
        <Grid
          columns={24}
          sx={{
            margin: 0,
            padding: 0,
            marginRight: "44px",
          }}
        >
          <Grid.Col span={12}>
            <Group>
              <Text className="hover" onClick={() => props.setSort("address")}>
                Address
              </Text>
              {props.sorting == "address" ? <Center>{sign}</Center> : null}
            </Group>
          </Grid.Col>
          <Grid.Col span={6}>
            <Group>
              <Text
                className="hover"
                onClick={() => props.setSort("sessionSum")}
              >
                Sessions
              </Text>
              {props.sorting == "sessionSum" ? <Center>{sign}</Center> : null}
            </Group>
          </Grid.Col>
          <Grid.Col span={6}>
            <Group>
              <Tooltip
                label={
                  "The Transcoders share of the next winning ticket based on their contribution"
                }
              >
                <Text
                  className="hover"
                  onClick={() => props.setSort("pendingSinceLastTicket")}
                >
                  Share
                </Text>
              </Tooltip>
              {props.sorting == "pendingSinceLastTicket" ? (
                <Center>{sign}</Center>
              ) : null}
            </Group>
          </Grid.Col>
        </Grid>
      </Stack>
      <Accordion
        variant="filled"
        styles={{
          item: {
            "&[data-active]": {
              backgroundColor: "#36393f",
            },
          },
        }}
      >
        {sortedTranscoders.map(function (item, idx) {
          let emphasize = false;
          if (props.selectedAddress == item.address) {
            emphasize = true;
          }
          if (!item.sessionSum > 0 && !item.capacitySum > 0 && showOnline) {
            return null;
          }
            const thisPP = props.poolInfo.pendingSinceLastTicketSum > 0
                ? (parseFloat(
                    (item.pendingSinceLastTicket || 0) /
                    props.poolInfo.pendingSinceLastTicketSum
                ) * 100).toFixed(1)
                : "0.0";
          return (
            <Accordion.Item value={item.address} key={"transcoder-" + idx}>
              <Stack
                spacing={0}
                sx={{
                  borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
                  borderRadius: "7px",
                }}
              >
                <Accordion.Control sx={{ paddingLeft: 0, paddingRight: 0 }}>
                  <Grid columns={24} sx={{ margin: "0" }}>
                    <Grid.Col span={12}>
                      {item.nickname != item.address ? (
                        <NickName
                          address={item.address}
                          nickname={item.nickname}
                          selectTranscoder={
                            emphasize ? null : props.selectTranscoder
                          }
                          emphasize={emphasize}
                        />
                      ) : (
                        <EthAddress
                          address={item.address}
                          selectTranscoder={
                            emphasize ? null : props.selectTranscoder
                          }
                          emphasize={emphasize}
                          cachedENS={props.cachedENS}
                        />
                      )}
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <Text>{item.sessionSum}</Text>
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <Group>
                        <Text
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {thisPP} %
                        </Text>
                      </Group>
                    </Grid.Col>
                  </Grid>
                </Accordion.Control>
                <Accordion.Panel>
                  <RegionInfo regions={item.regions} address={item.address} />
                </Accordion.Panel>
              </Stack>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </Stack>
  );
}
